import { HttpRequest } from "@/core/common/http/http-request";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { PointPriceConfigurationDto } from "@/core/features/point-price-configurations/point-price-configuration.dto";
import { CreatePointPriceConfigurationDto } from "@/core/features/point-price-configurations/create-point-price-configuration.dto";
import { UpdatePointPriceConfigurationDto } from "@/core/features/point-price-configurations/update-point-price-configuration.dto";

export class PointPriceConfigurationsResource extends ResourceBaseService<
  PointPriceConfigurationDto,
  CreatePointPriceConfigurationDto,
  UpdatePointPriceConfigurationDto
> {
  protected EntityDto = PointPriceConfigurationDto;
  protected CreateEntityDto = CreatePointPriceConfigurationDto;
  protected UpdateEntityDto = UpdatePointPriceConfigurationDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/point-price-configurations");
  }

  async importPointPriceConfigurations(file: File): Promise<{ jobId: string }> {
    const formData = new FormData();
    formData.append("file", file);

    return this.apiHttpClient.request<FormData, { jobId: string }>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/import",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }

  async downloadImportTemplate(): Promise<void> {
    return this.downloadExcel(undefined, "/import/template", "plantilla-puntos-por-puesto");
  }
}
